import * as React from 'react'

import { observer } from 'mobx-react'

import CompanyDomainsInput from '~/client/src/desktop/components/CompanyDomainsInput/CompanyDomainsInput'
import { InfoIcon } from '~/client/src/shared/components/icons/InfoIcon'
import TooltipWrapper from '~/client/src/shared/components/TooltipWrapper/TooltipWrapper'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import ProjectSettingsStore from '../ProjectSettings.store'
import SignUpNotificationRulesSection from './SignUpNotificationRulesSection'
import { SignUpQR } from './SignUpQR'

interface IProps {
  store: ProjectSettingsStore
}

const DomainsAndSignUp: React.FC<IProps> = observer(({ store }) => {
  return (
    <div className="tw:flex tw:flex-col tw:gap-8 tw:items-center tw:p-8 tw:w-full">
      {/* Section 1: New User Signup Workflow */}
      <div className="tw:flex tw:flex-col tw:gap-3 tw:items-start tw:w-full tw:max-w-[782px]">
        <h2 className="tw:text-title-lg tw:text-foreground">
          {Localization.translator.newUserSignupWorkflow}
        </h2>

        <div
          className={
            'tw:rounded-lg tw:border tw:border-solid tw:border-border tw:bg-background tw:p-4 tw:flex tw:flex-col tw:gap-6 tw:w-full'
          }
        >
          {/* White List Domains */}
          <div className="tw:flex tw:flex-col tw:gap-2 tw:w-full">
            <div className="tw:flex tw:gap-1 tw:items-center">
              <span className="tw:text-label-lg tw:text-muted-foreground">
                {Localization.translator.whiteListDomains}
              </span>
              <TooltipWrapper
                className="tw:inline-flex tw:items-center"
                content={
                  <div className="tw:max-w-[300px] tw:text-body-sm">
                    <p>{Localization.translator.whiteListDomainsTooltip}</p>
                    <p className="tw:mt-2 tw:font-semibold">
                      {Localization.translator.whiteListDomainsTooltipNote}
                    </p>
                  </div>
                }
              >
                <InfoIcon size="xs" className="tw:block" />
              </TooltipWrapper>
            </div>
            <CompanyDomainsInput isRequiredTextHidden={true} companyId={null} />
          </div>

          {/* QR Code */}
          <div className="tw:flex tw:flex-col tw:gap-2 tw:w-full">
            <SignUpQR.Provider
              signUpUrl={store.projectSignUpUrl}
              projectName={store.projectName}
              onCopyLink={store.copySignUpLinkToClipboard}
            >
              <div className="tw:flex tw:flex-col tw:gap-1 tw:items-center tw:w-full">
                <SignUpQR.Code />
                <div className="tw:flex tw:flex-col tw:gap-5 tw:items-center tw:w-full">
                  <p className="tw:text-[22px] tw:font-semibold tw:leading-7 tw:text-foreground tw:text-center">
                    {Localization.translator.signUp}
                  </p>
                  <div className="tw:flex tw:gap-2 tw:items-start">
                    <SignUpQR.PrintButton />
                    <SignUpQR.ShareButton />
                    <SignUpQR.DownloadButton />
                  </div>
                </div>
              </div>
              <SignUpQR.ShareDialog />
              <SignUpQR.PrintTarget />
            </SignUpQR.Provider>
          </div>
        </div>
      </div>

      {/* Section 2: Approval Configuration */}
      <div className="tw:flex tw:flex-col tw:gap-3 tw:items-start tw:w-full tw:max-w-[782px]">
        <h2 className="tw:text-title-lg tw:text-foreground">
          {Localization.translator.approvalConfiguration}
        </h2>

        <div
          className={
            'tw:rounded-lg tw:border tw:border-solid tw:border-border tw:bg-background tw:p-4 tw:flex tw:flex-col tw:gap-4 tw:w-full'
          }
        >
          <SignUpNotificationRulesSection />
        </div>
      </div>
    </div>
  )
})

export default DomainsAndSignUp
